import { Chip } from '@mui/material';

interface CobroBadgeProps {
  cobrado: boolean;
}

export function CobroBadge({ cobrado }: CobroBadgeProps): JSX.Element {
  return (
    <Chip
      label={cobrado ? 'Cobrado' : 'No cobrado'}
      size="small"
      color={cobrado ? 'success' : 'warning'}
    />
  );
}
